import * as Y from 'yjs';

/** Bytes that are not a version file: not gzip, or not a Yjs update once decompressed (spec §11.1). */
export class VersionFileError extends Error {
  readonly code = 'corrupt' as const;
  constructor() {
    super('corrupt');
    this.name = 'VersionFileError';
  }
}

const through = async (bytes: Uint8Array, stream: CompressionStream | DecompressionStream): Promise<Uint8Array> =>
  new Uint8Array(await new Response(new Blob([bytes as Uint8Array<ArrayBuffer>]).stream().pipeThrough(stream)).arrayBuffer());

/** A version file (plan P8 Ruling 3): the full Yjs update of the document, gzip, no header. */
export async function encodeVersion(doc: Y.Doc): Promise<Uint8Array> {
  return through(Y.encodeStateAsUpdate(doc), new CompressionStream('gzip'));
}

/** A separate document holding the version; throws VersionFileError for anything else. */
export async function decodeVersion(bytes: Uint8Array): Promise<Y.Doc> {
  let update: Uint8Array;
  try {
    update = await through(bytes, new DecompressionStream('gzip'));
  } catch {
    throw new VersionFileError();
  }
  const doc = new Y.Doc();
  try {
    Y.applyUpdate(doc, update);
  } catch {
    throw new VersionFileError();
  }
  return doc;
}
